/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  SECTION_CONTROL_ALIGNMENT
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { ReportService } from 'projects/icemedx-lib/src/services/report/report.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';

import { report, Report_Layout_Type, Report_Mode_Type } from '../../../../icemedx-lib/src/models/reports/report';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { reporttemplate } from 'projects/icemedx-lib/src/models/reports/reporttemplate';
import { reportfilter, OperatorTypes } from 'projects/icemedx-lib/src/models/reports/subs/reportfilter';
import { lodgemembershipsummary } from '../../../../icemedx-lib/src/models/stats/lodgemembshipsummary';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { payer } from '../../../../icemedx-lib/src/models/domain/payer';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { vendor } from '../../../../icemedx-lib/src/models/domain/vendor';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';

const NameOfReport: string = "NameOfReport";
const TypeOfReport: string = "TypeOfReport";
const RunFrequency: string = "RunFrequency";
const CancelReport: string = "CancelReport";
const SaveReport: string = "SaveReport";
const FromDate: string = "FromDate";
const ToDate: string = "ToDate";
const TemplateType: string = "report_template_type";


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  providers: [IceNavService, AppService]
})
export class ReportComponent implements OnInit {
  // Currency and Currencies
  countries: basecode[] = [];
  currencies: basecode[] = [];

  // data members
  reportObj: report = new report();
  templateDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  apiToUse: string = "";
  reportDomainType: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  reportDomain: string = "";

  // report member settings
  reportMode: Report_Mode_Type = Report_Mode_Type.modeDesign;
  reportLayoutType: Report_Layout_Type = Report_Layout_Type.rltStaticLayout;

  nameOfReportCtrl: IcecontrolSettings = null;
  typeOfReportCtrl: IcecontrolSettings = null;
  runFrequencyCtrl: IcecontrolSettings = null;
  fromDateCtrl: IcecontrolSettings = null;
  toDateCtrl: IcecontrolSettings = null;
  templateTypeCtrl: IcecontrolSettings = null;
  templateTableSettings: IcemattableSettings = null;
  reportPanelSettings: IcepanelSettings = null;
  reportSections: IcepanelsectionSettings[] = null;

  reportViewSettings: IcepanelcontainerSettings = null;

  // Lodge Membership Data
  lodgeMembershipSection: IcepanelsectionSettings = null;

  memberShipReportDateCtrl: IcecontrolSettings = null;
  nameOfOrgCtrl: IcecontrolSettings = null;
  address1OfOrgCtrl: IcecontrolSettings = null;
  address2OfOrgCtrl: IcecontrolSettings = null;
  cityOfOrgCtrl: IcecontrolSettings = null;
  postalCodeOfOrgCtrl: IcecontrolSettings = null;
  countryOfOrgCtrl: IcecontrolSettings = null;
  stateOfOrgCtrl: IcecontrolSettings = null;
  provinceOfOrgCtrl: IcecontrolSettings = null;
  charterNumberCtrl: IcecontrolSettings = null;
  memberShipReportStartDateCtrl: IcecontrolSettings = null;
  memberShipReportEndDateCtrl: IcecontrolSettings = null;
  functioningStatusCtrl: IcecontrolSettings = null;
  numberOfMembersCtrl: IcecontrolSettings = null;
  activeMembersCtrl: IcecontrolSettings = null;
  meetingLocationCtrl: IcecontrolSettings = null;
  activitiesCtrl: IcecontrolSettings = null;
  otherActivitiesCtrl: IcecontrolSettings = null;
  transferName1Ctrl: IcecontrolSettings = null;
  transferTo1Ctrl: IcecontrolSettings = null;
  transferEffectiveDate1Ctrl: IcecontrolSettings = null;
  transferName2Ctrl: IcecontrolSettings = null;
  transferTo2Ctrl: IcecontrolSettings = null;
  transferEffectiveDate2Ctrl: IcecontrolSettings = null;
  remitPeriodCtrl: IcecontrolSettings = null;
  remittedAmountCtrl: IcecontrolSettings = null;
  suggestionsCtrl: IcecontrolSettings = null;

  getAppService(): AppService {
    return this.appSvc;
  }

  getNavService(): IceNavService {
    return this.navSvc;
  }

  getLoginService(): LoginService {
    return this.loginSvc;
  }

  getReportService(): ReportService {
    return this.rptService;
  }

  getRouter(): Router {
    return this.router;
  }

  getCodeService(): MedicalcodesService {
    return this.codeSvc;
  }

  getReportMode(): Report_Mode_Type {
    return this.reportMode;
  }
  setReportMode(rptMode: Report_Mode_Type): void {
    this.reportMode = rptMode;
  }

  getReportLayoutType(): Report_Layout_Type {
    return this.reportLayoutType;
  }
  setReportLayoutType(rptLayoutType: Report_Layout_Type): void {
    this.reportLayoutType = rptLayoutType;
  }

  getReportDomainType(): IceTypes.ACCOUNT_TYPE {
    return this.reportDomainType;
  }
  getReportDomain(): string {
    return this.reportDomain;
  }
  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private loginSvc: LoginService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private rptService: ReportService,
    private schService: ScheduleService,
    private codeSvc: MedicalcodesService,
    private domainSvc: DomainService,
    private changeDetectorRefs: ChangeDetectorRef) {

    this.setReportMode(Report_Mode_Type.modePreview);
    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Reports", {}, true, "/reports");
    this.appSvc.addBreadcrumb("Report", {}, true, "");

    this.activatedRoute.params.subscribe(next => {
      if (next == null || next.key == "0" || next.length == 0) {
        this.reportViewSettings = this.viewSetup(null);
      }
      else {
        this.reportDomainType = IceTypes.ACCOUNT_TYPE.actNone;
        if (next.domaintype == null)
          this.reportDomainType = this.appSvc.getCurrentAccountType();
        else
          this.reportDomainType = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(next.domaintype);

        this.reportDomain = "";
        if (next.domain == null)
          this.reportDomain = this.appSvc.getCurrentAccount();
        else
          this.reportDomain = next.domain;


        this.apiToUse = this.getAPIBasePath(this.reportDomainType);

        switch (this.reportDomainType) {
          case IceTypes.ACCOUNT_TYPE.actProvider:
          case IceTypes.ACCOUNT_TYPE.actFacility: {
            this.domainSvc.getProvider(this.reportDomain).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  let pro: provider = data[0];
                  this.currencies = pro.CURRENCIES;
                  this.countries = pro.COUNTRIES;
                }
              },
              error => {
                // To do
              }
            );
            break;
          }
          case IceTypes.ACCOUNT_TYPE.actPharmacy: {
            this.domainSvc.getPharmacy(this.reportDomain).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  let phrm: pharmacy = data[0];
                  this.currencies = phrm.CURRENCIES;
                  this.countries = phrm.COUNTRIES;
                }
              },
              error => {
                // To do
              }
            );
            break;
          }
          case IceTypes.ACCOUNT_TYPE.actPayer: {
            this.domainSvc.getPayer(this.reportDomain).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  let pyr: payer = data[0];
                  this.currencies = pyr.CURRENCIES;
                  this.countries = pyr.COUNTRIES;
                }
              },
              error => {
                // To do
              }
            );
            break;
          }
          case IceTypes.ACCOUNT_TYPE.actVendor: {
            this.domainSvc.getVendor(this.reportDomain).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  let ven: vendor = data[0];
                  this.currencies = ven.CURRENCIES;
                  this.countries = ven.COUNTRIES;
                }
              },
              error => {
                // To do
              }
            );
            break;
          }
          case IceTypes.ACCOUNT_TYPE.actPatient: {
            this.domainSvc.getPatient(this.reportDomain, this.appSvc.getCurrentAccount()).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  let pt: patient = data[0];
                  this.currencies = pt.CURRENCIES;
                  this.countries = pt.COUNTRIES;
                }
              },
              error => {
                // To do
              }
            );
            break;
          }
        }

        this.rptService.getReport(this.apiToUse, this.reportDomain, this.reportDomainType, next.key).subscribe(
          data => {
            if (data && data.length > 0 && data[0] != null) {
              this.reportViewSettings = this.viewSetup(data[0]);
            }
          },
          error => {
            console.log(JSON.stringify(this.rptService.getLastErrors()));
          });
      }
    });
  }

  getAPIBasePath(domaintype: IceTypes.ACCOUNT_TYPE): string {
    let ret = "";
    switch (domaintype) {
      case IceTypes.ACCOUNT_TYPE.actFacility:
      case IceTypes.ACCOUNT_TYPE.actProvider:
        ret = "providers";
        break;
      case IceTypes.ACCOUNT_TYPE.actPharmacy:
        ret = "pharmacies";
        break;
      case IceTypes.ACCOUNT_TYPE.actPayer:
        ret = "payers";
        break;
      case IceTypes.ACCOUNT_TYPE.actPatient:
        ret = "patients";
        break;
      case IceTypes.ACCOUNT_TYPE.actVendor:
        ret = "vendors";
        break;
      default:
        this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error reporting API not supported. ");
    }
    return ret;
  }

  viewLodgeMembership(): IcepanelsectionSettings {
    let sec: IcepanelsectionSettings = null;
    try {
      let lodgeMemSummary: lodgemembershipsummary = null;
      if (this.reportObj.LODGE_MEMBERSHIP_SUMMARY.length == 0) {
        lodgeMemSummary = new lodgemembershipsummary();
        this.reportObj.LODGE_MEMBERSHIP_SUMMARY.push(lodgeMemSummary);
      }
      else {
        lodgeMemSummary = this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0];
      }

      this.memberShipReportDateCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipReportDate", "Date of Summary")
        .setControlName("MembershipReportDate")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.date_of_summary) ? Iceutility.GetLocalDate(lodgeMemSummary.date_of_summary) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.date_of_summary), [Validators.required]);

      this.nameOfOrgCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "NameOfOrganization", "Name of Organization")
        .setControlName("NameOfOrganization")
        .createFormControl(lodgeMemSummary.organization_name, [Validators.required]);

      this.address1OfOrgCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "Address1OfOrganization", "Address 1")
        .setControlName("Address1OfOrganization")
        .createFormControl(lodgeMemSummary.street1, [Validators.required]);

      this.address2OfOrgCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "Address2OfOrganization", "Address 2")
        .setControlName("Address2OfOrganization")
        .createFormControl(lodgeMemSummary.street2, []);

      this.cityOfOrgCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "CityOfOrganization", "City")
        .setControlName("CityOfOrganization")
        .createFormControl(lodgeMemSummary.city, [Validators.required]);

      this.stateOfOrgCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "StateOfOrganization", "Enter State")
        .setControlName("StateOfOrganization")
        .createFormControl(lodgeMemSummary.state_id, [Validators.required]);

      this.countryOfOrgCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "CountryOfOrganization", "Enter Country")
        .setControlName("CountryOfOrganization")
        .createFormControl(lodgeMemSummary.country_id, [Validators.required]);

      this.appSvc.setStateIDList(this.codeSvc, this.stateOfOrgCtrl, "");
      this.appSvc.setCountryCodeList(this.codeSvc, this.countryOfOrgCtrl);

      this.postalCodeOfOrgCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "PostalCodeOfOrganization", "Postal Code")
        .setControlName("PostalCodeOfOrganization")
        .createFormControl(lodgeMemSummary.postal_code, [Validators.required]);

      this.provinceOfOrgCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "ProvinceOfOrganization", "Province")
        .setControlName("ProvinceOfOrganization")
        .createFormControl(lodgeMemSummary.province, []);

      this.charterNumberCtrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipCharterNumber", "Local Number")
        .setControlName("MembershipCharterNumber")
        .createFormControl(lodgeMemSummary.charter_number, [Validators.required]);

      this.memberShipReportStartDateCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipReportStartDate", "Starting Date of Reporting Period")
        .setControlName("MembershipReportStartDate")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.starting_date) ? Iceutility.GetLocalDate(lodgeMemSummary.starting_date) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.starting_date), [Validators.required]);

      this.memberShipReportEndDateCtrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipReportEndDate", "Ending Date of Reporting Period")
        .setControlName("MembershipReportEndDate")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.ending_date) ? Iceutility.GetLocalDate(lodgeMemSummary.ending_date) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.ending_date), [Validators.required]);

      this.functioningStatusCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "200px" }, null, null, "MembershipFunctioningStatus", "Is functioning status")
        .setControlName("MembershipFunctioningStatus")
        .createFormControl(lodgeMemSummary.functioning_status, [Validators.required])
        .setOptions([
          { value: "satisfactorily", name: "Satisfactorily" },
          { value: "having problems", name: "Having Problems" },
        ]);

      this.numberOfMembersCtrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipNumberOfMembers", "Number of Members")
        .setControlName("MembershipNumberOfMembers")
        .createFormControl(lodgeMemSummary.number_of_members, [Validators.required]);

      this.activeMembersCtrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipActiveMembers", "Active Members")
        .setControlName("MembershipActiveMembers")
        .createFormControl(lodgeMemSummary.active_members, [Validators.required]);

      this.meetingLocationCtrl = new IcecontrolSettings("iceinput", { width: "400px" }, null, null, "MembershipMeetingLocation", "Meeting Dates and Location")
        .setControlName("MembershipMeetingLocation")
        .createFormControl(lodgeMemSummary.meeting_location, [Validators.required]);

      this.activitiesCtrl = new IcecontrolSettings("icetextarea", { width: "400px" }, null, null, "MembershipActivities", "Activities and Functions held during the month")
        .setControlName("MembershipActivities")
        .createFormControl(lodgeMemSummary.activities, [Validators.required]);

      this.otherActivitiesCtrl = new IcecontrolSettings("icetextarea", { width: "400px" }, null, null, "MembershipOtherActivity", "Other Activities")
        .setControlName("MembershipOtherActivity")
        .createFormControl(lodgeMemSummary.other_activities, []);

      this.transferName1Ctrl = new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "MembershipTransferName1", "Transfer Name 1")
        .setControlName("MembershipTransferName1")
        .createFormControl(lodgeMemSummary.transfer_name1, []);

      this.transferTo1Ctrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipTransferTo1", "Transfer To 1")
        .setControlName("MembershipTransferTo1")
        .createFormControl(lodgeMemSummary.transfer_to_charter1, []);

      this.transferEffectiveDate1Ctrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipTransferEffectiveDate1", "Transfer Effective 1")
        .setControlName("MembershipTransferEffectiveDate1")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.transfer_effective_date1) ? Iceutility.GetLocalDate(lodgeMemSummary.transfer_effective_date1) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.transfer_effective_date1), []);

      this.transferName2Ctrl = new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "MembershipTransferName2", "Transfer Name 2")
        .setControlName("MembershipTransferName2")
        .createFormControl(lodgeMemSummary.transfer_name2, []);

      this.transferTo2Ctrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipTransferTo2", "Transfer To 2")
        .setControlName("MembershipTransferTo2")
        .createFormControl(lodgeMemSummary.transfer_to_charter2, []);

      this.transferEffectiveDate2Ctrl = new IcecontrolSettings("icedatepicker", { width: "200px" }, null, null, "MembershipTransferEffectiveDate2", "Transfer Effective 2")
        .setControlName("MembershipTransferEffectiveDate2")
        .createFormControl(Iceutility.isTextDateTime(lodgeMemSummary.transfer_effective_date2) ? Iceutility.GetLocalDate(lodgeMemSummary.transfer_effective_date2) : Iceutility.ConvertFromDotNetServerTime(lodgeMemSummary.transfer_effective_date2), []);

      this.remitPeriodCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "200px" }, null, null, "MembershipPeriod", "Remit Month")
        .setControlName("MembershipPeriod")
        .createFormControl(lodgeMemSummary.remit_period, [Validators.required])
        .setOptions([
          { value: "January", name: "January" },
          { value: "February", name: "February" },
          { value: "March", name: "March" },
          { value: "April", name: "April" },
          { value: "May", name: "May" },
          { value: "June", name: "June" },
          { value: "July", name: "July" },
          { value: "August", name: "August" },
          { value: "September", name: "September" },
          { value: "October", name: "October" },
          { value: "November", name: "November" },
          { value: "December", name: "December" },
        ]);

      this.remittedAmountCtrl = new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "MembershipRemittedAmount", "Amount Remitted")
        .setControlName("MembershipRemittedAmount")
        .createFormControl(lodgeMemSummary.remitted_amount, [Validators.required]);

      this.suggestionsCtrl = new IcecontrolSettings("icetextarea", { width: "400px" }, null, null, "MembershipSuggestions", "Suggestions")
        .setControlName("MembershipSuggestions")
        .createFormControl(lodgeMemSummary.suggestions, []);

      sec = new IcepanelsectionSettings(
        "LodgeMembershipSection", { class: [], styles: { width: "100%" } }, [], [
          this.memberShipReportDateCtrl,
          this.charterNumberCtrl,
          this.nameOfOrgCtrl,
          this.address1OfOrgCtrl,
          this.address2OfOrgCtrl,
          this.cityOfOrgCtrl,
          this.postalCodeOfOrgCtrl,
          this.countryOfOrgCtrl,
          this.stateOfOrgCtrl,
          this.provinceOfOrgCtrl,
          this.memberShipReportStartDateCtrl,
          this.memberShipReportEndDateCtrl,
          this.functioningStatusCtrl,
          this.numberOfMembersCtrl,
          this.activeMembersCtrl,
          this.meetingLocationCtrl,
          this.activitiesCtrl,
          this.otherActivitiesCtrl,
          this.transferName1Ctrl,
          this.transferTo1Ctrl,
          this.transferEffectiveDate1Ctrl,
          this.transferName2Ctrl,
          this.transferTo2Ctrl,
          this.transferEffectiveDate2Ctrl,
          this.remitPeriodCtrl,
          this.remittedAmountCtrl,
          this.suggestionsCtrl,
          //new IcecontrolSettings("icepanelbutton", { text: "Reset", class: [], glyphClass: "fa-plus" }, null, null, "MembershipResetButton"),
      ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true);
    }
    catch (e) {
      console.log(e);
    }
    return sec;
  }

  viewSetup(rep: report): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (rep == null) {
        rep = new report();
        rep.rpt_name = "Untitled";
      }

      this.reportObj = rep;
      this.reportObj.report_type = <IceTypes.ReportType>this.reportObj.report_type;

      this.nameOfReportCtrl = new IcecontrolSettings("iceinput", { width: "250px" }, null, null, NameOfReport, "Name of Report")
        .setControlName(NameOfReport)
        .createFormControl(this.reportObj.rpt_name, [Validators.required]);
      this.typeOfReportCtrl = new IcecontrolSettings("iceselect", { menuItems: ReportService.getReportTypes(), width: "250px" }, null, null, TypeOfReport, "Type of Report")
        .setControlName(TypeOfReport)
        .createFormControl(this.reportObj.report_type, [Validators.required]);
      this.runFrequencyCtrl = new IcecontrolSettings("iceselect", { menuItems: ScheduleService.getRecurringTypes(), width: "250px" }, null, null, RunFrequency, "Run Frequency")
        .setControlName(RunFrequency)
        .createFormControl(this.reportObj.recurring_type, [Validators.required]);

      let panelTag = "ReportView";
      let panelKey = Iceutility.guid(false);
      let controls: IcecontrolSettings[] = [
        this.nameOfReportCtrl,
        this.typeOfReportCtrl,
        this.runFrequencyCtrl,
      ];

      /////////////////////////////////////////////////
      // Filters
      let fromVal = Iceutility.getDateTextEx(Iceutility.GetLocalDate());
      let toVal = fromVal;
      let thisTemplate: reporttemplate = null;

      //REPTEMPL-OTHER
      if (Iceutility.isdefined(this.reportObj.RPTTEMPLATES) && this.reportObj.RPTTEMPLATES.length > 0) {
        thisTemplate = this.reportObj.RPTTEMPLATES[0];
        if (thisTemplate != null && Iceutility.isdefined(thisTemplate.RPTFILTER) && thisTemplate.RPTFILTER.length > 0) {
          let thisFilter = thisTemplate.RPTFILTER[0];
          if (thisFilter != null) {
            let parts = thisFilter.value.split(",");
            if (parts.length > 0)
              fromVal = parts[0];
            if (parts.length > 1)
              toVal = parts[1];
          }
        }
      }

      this.fromDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", value: Iceutility.GetDateText(Iceutility.GetLocalDate()), timevalue: "00:00:00 AM" }, null, null, FromDate)
        .setControlName(FromDate)
        .createFormControl(Iceutility.GetLocalDate(fromVal), [Validators.required]);
      this.toDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", value: Iceutility.GetDateText(Iceutility.GetLocalDate()), timevalue: "11:59:59 PM" }, null, null, ToDate)
        .setControlName(ToDate)
        .createFormControl(Iceutility.GetLocalDate(toVal), [Validators.required]);

      let dateFilterControls: IcecontrolSettings[] = [
        this.fromDateCtrl,
        this.toDateCtrl,
      ];

      /////////////////////////////////////////////////
      // Templates
      this.templateTypeCtrl = new IcecontrolSettings("iceselect", { width: "250px" }, null, null, TemplateType, "Type of Template")
        .setControlName(TemplateType)
        .createFormControl(0, [Validators.required]); // To do: fix this as it is not working formgroup

      this.templateTableSettings = new IcemattableSettings(
        "TemplateTable",
        [
          new iceColumnDefinition("report_template_type", "Templates", false, false,
            this.templateTypeCtrl
          ),
          new iceColumnDefinition("report_template_key", "report_template_key", true),
        ],
        this.templateDataSource,
        [],
        false,
        null,
        true
      ).showAddButton(true);

      let templateTables: IcemattableSettings[] = [
        this.templateTableSettings
      ];
      let templateGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, templateTables)
      ];

      this.reportSections = [
        new IcepanelsectionSettings("TitleSection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
        new IcepanelsectionSettings("DateFilterSection", { class: ["yalla"], styles: { width: "100%" } }, null, dateFilterControls, null),
        new IcepanelsectionSettings("TemplateSection", { class: [], styles: { width: "100%" } }, templateGroups, [], null)
      ];

      let headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
      ];

      this.reportPanelSettings = new IcepanelSettings(panelTag, panelKey, "Report", "", this.reportSections, headerControls)
        .enableForm();
      let panels: IcepanelSettings[] = [
        this.reportPanelSettings
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("ReportViewContainer", panelrows);

      this.templateDataSource.data = this.reportObj.RPTTEMPLATES;

      this.codeSvc.getCodes("SUBTYPE_ITEM", "", "", "", "", IceTypes.ACCOUNT_TYPE.actNone).subscribe(
        data => {
          if (data != null) {
            let reptmps = data.filter(c => c.code.indexOf("REPTEMPL-") >= 0).map(c => { return { value: c.sub_type, name: c.title, code: c.code, keyword: c.keyword } })
            this.templateTypeCtrl.setOptions(reptmps);
            if (thisTemplate != null) {
              let thisForm: FormGroup = this.templateTableSettings.getFormGroupByPrimaryKey(thisTemplate.report_template_key);
              if (thisForm != null && thisForm.get(TemplateType) != null) {
                thisForm.get(TemplateType).setValue(thisTemplate.report_template_type);

                if (this.reportSections == null) return;
                let foundTypes = reptmps.filter(type => type.value == thisTemplate.report_template_type && type.code == "REPTEMPL-ACCT-SUM-LODGE");
                if (foundTypes.length > 0) {
                  if (this.lodgeMembershipSection == null) {
                    this.lodgeMembershipSection = this.viewLodgeMembership();
                    this.reportSections.push(this.lodgeMembershipSection);
                  }
                  else {
                    this.lodgeMembershipSection.setShow(true);
                  }
                }
              }
            }
          }
        },
        error => {
        });
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  public onControlChange(event) {
    try {
      if (event.selectSettings != null) {
        switch (event.selectSettings.id) {
          case "report_template_type":
            if (this.reportSections == null) break;

            let ctrlType: IcecontrolSettings = event.selectSettings;
            let foundTypes = ctrlType.getOptions().filter(type => type.value == event.value && type.code == "REPTEMPL-ACCT-SUM-LODGE");
            if (foundTypes.length > 0) {
              if (this.lodgeMembershipSection == null) {
                this.lodgeMembershipSection = this.viewLodgeMembership();
                this.reportSections.push(this.lodgeMembershipSection);
              }
              else {
                this.lodgeMembershipSection.setShow(true);
              }
            }
            else {
              if (this.lodgeMembershipSection != null) {
                this.lodgeMembershipSection.setShow(false);
              }
            }
            break;
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  public onAddRowButtonClick(event) {
    try {
      let newTpl: reporttemplate = new reporttemplate();
      newTpl.report_template_key = Iceutility.guid(true);
      this.reportObj.RPTTEMPLATES.push(newTpl);
      this.templateDataSource.data = this.reportObj.RPTTEMPLATES;
      this.changeDetectorRefs.detectChanges();
    }
    catch (e) {
      console.log(e);
    }
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == CancelReport) {
      // To do: Save Modified Prompt
      this.router.navigate([this.navSvc.buildRoute("reports", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let reportPanel: IcepanelSettings = event.headerCtrl;
      let reportForm: FormGroup = reportPanel.getForm();
      if (reportForm == null || false == reportForm.valid) {

        // To do log error
        return;
      }

      this.reportObj.rpt_name = reportForm.get(NameOfReport).value;
      this.reportObj.report_type = <IceTypes.ReportType>Iceutility.toLong(reportForm.get(TypeOfReport).value);
      this.reportObj.recurring_type = <IceTypes.recurringtype>Iceutility.toLong(reportForm.get(RunFrequency).value);
      if (this.reportObj.report_type != IceTypes.ReportType.rtClincialData
        && this.reportObj.report_type != IceTypes.ReportType.rtAccountingSummary) {
        this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error report type not supported. " + this.reportObj.report_type);
        return;
      }
      let fromVal = reportForm.get(FromDate).value;
      let newFrom = fromVal.toLocaleDateString() + " 00:00:00 AM"
      fromVal = Iceutility.GetLocalDate(newFrom);
      let toVal: Date = reportForm.get(ToDate).value;
      let newTo = toVal.toLocaleDateString() + " 11:59:59 PM"
      toVal = Iceutility.GetLocalDate(newTo);
      if (false == Iceutility.isdefined(this.reportObj.RPTTEMPLATES) || this.reportObj.RPTTEMPLATES.length == 0) {
        this.reportObj.RPTTEMPLATES = [];
      }

      for (let itpl = 0; itpl < this.templateDataSource.data.length; itpl++) {
        let thisTplRec = this.templateDataSource.data[itpl];
        if (thisTplRec == null) {
          this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error: invalid template selection.");
          return;
        }
        let thisForm: FormGroup = this.templateTableSettings.getFormGroupByPrimaryKey(thisTplRec.report_template_key);
        if (thisForm == null) {
          this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error invalid template record.");
          return;
        }

        let tempTypeFrmCtrl = thisForm.get(TemplateType);
        if (tempTypeFrmCtrl != null)
          thisTplRec.report_template_type = tempTypeFrmCtrl.value;

        if (this.reportObj.LODGE_MEMBERSHIP_SUMMARY.length > 0 && this.lodgeMembershipSection != null && this.lodgeMembershipSection.getShow()) {
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].date_of_summary = Iceutility.convertToUTCEx(this.memberShipReportDateCtrl.getFormControl().value);
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].organization_name = this.nameOfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].street1 = this.address1OfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].street2 = this.address2OfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].city = this.cityOfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].postal_code = this.postalCodeOfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].country_id = this.countryOfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].state_id = this.stateOfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].province = this.provinceOfOrgCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].charter_number = this.charterNumberCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].starting_date = Iceutility.convertToUTCEx(this.memberShipReportStartDateCtrl.getFormControl().value);
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].ending_date = Iceutility.convertToUTCEx(this.memberShipReportEndDateCtrl.getFormControl().value);
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].functioning_status = this.functioningStatusCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].number_of_members = this.numberOfMembersCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].active_members = this.activeMembersCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].meeting_location = this.meetingLocationCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].activities = this.activitiesCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].other_activities = this.otherActivitiesCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].transfer_name1 = this.transferName1Ctrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].transfer_to_charter1 = this.transferTo1Ctrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].transfer_effective_date1 = Iceutility.convertToUTCEx(this.transferEffectiveDate1Ctrl.getFormControl().value);
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].transfer_name2 = this.transferName2Ctrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].transfer_to_charter2 = this.transferTo2Ctrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].transfer_effective_date2 = Iceutility.convertToUTCEx(this.transferEffectiveDate2Ctrl.getFormControl().value);
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].remit_period = this.remitPeriodCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].remitted_amount = this.remittedAmountCtrl.getFormControl().value;
          this.reportObj.LODGE_MEMBERSHIP_SUMMARY[0].suggestions = this.suggestionsCtrl.getFormControl().value;
        }

        let colname = "";
        let tablename = "";
        switch (this.reportObj.report_type)
        {
          case IceTypes.ReportType.rtClincialData:
            colname = "time_slot_start";
            tablename = "encounter";
            break;
          case IceTypes.ReportType.rtAccountingSummary:
            colname = "journal_date";
            tablename = "journal";
            break;
        }

        if (colname.length == 0) continue;

        // Update filter
        let dateAry = thisTplRec.RPTFILTER.filter(f => f.columnname.toLowerCase() == colname || f.columnname == '' || f.columnname == null);

        let dateFilter: reportfilter = null;
        if (dateAry != null && dateAry.length > 0) {
          dateFilter = dateAry[0];
          dateFilter.columnname = colname;
          dateFilter.tablename = tablename;
          dateFilter.operatortype = OperatorTypes.otBetween;
        }
        else {
          dateFilter = new reportfilter();
          thisTplRec.RPTFILTER.push(dateFilter);

          if (dateFilter.columnname == null || dateFilter.columnname.length == 0) {
            dateFilter.columnname = colname;
            dateFilter.tablename = tablename;
          }
          dateFilter.operatortype = OperatorTypes.otBetween;
        }

        dateFilter.value = Iceutility.convertToUTCEx(fromVal) + "," + Iceutility.convertToUTCEx(toVal); 
      }

      let acttype = this.appSvc.getCurrentAccountType();
      switch (acttype) {
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider:
          this.apiToUse = "providers";
          break;
        case IceTypes.ACCOUNT_TYPE.actPharmacy:
          this.apiToUse = "pharmacies";
          break;
        case IceTypes.ACCOUNT_TYPE.actPayer:
          this.apiToUse = "payers";
          break;
        default:
          this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error reporting API not supported. ");
          return;
      }

      this.rptService.updateReport(this.apiToUse, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.reportObj).subscribe(
        data => {
          this.getRouter().navigate([this.getNavService().buildRoute("reports", false)]);
        },
        error => {
          console.log(JSON.stringify(this.rptService.getLastErrors()));
        });
    }
  }
}
